import React, { useEffect, useState, useRef } from 'react';
import ViewDetails from '@jda/lui-common-icon-library/ui/ViewDetails';
import DetailedTable from '../DetailedTable';
import moment from 'moment';
import { Dialog, DialogTitle, DialogContent, Grid, Button, DialogActions, Typography, Box } from '@material-ui/core';
import { Loading } from '../../Loading';
import JsonEditor from '../JsonEditor';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  textField: {
    width: '80%'
  },
  selectField: {
    width: '100%'
  },
  mainGrid: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(0),
    backgroundColor: theme.palette.background.paper,
    width: 'auto',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    borderRadius: theme.spacing(0.5)
  }
}));

interface ManageRelationsProps {
  dialogOpen: true | false;
  handleDialogClose: any;
  formData?: any;
  mode: any;
  participantCode: any;
  rowData?: any;
  tableId?: any;
  refresh: any;
  totalElements: any;
}

const AuditDetailsDialog = (props: ManageRelationsProps) => {
  const [request, setRequest] = useState({});
  const [entity1, setEntity1] = useState({});
  const [entity2, setEntity2] = useState({});

  const subcolumns = [
    {
      title: 'Updated Date',
      field: 'lastUpdated',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => moment(rowData?.entity?.lastUpdated).format('MM/DD/YYYY hh:mm:ss A')
    },
    {
      title: 'Updated By',
      field: 'lastUpdatedBy',
      headerStyle: { zIndex: 10 },
      render: (rowData: any) => {
        return rowData?.entity?.lastUpdatedBy;
      }
    },
    {
      title: 'Revision ID',
      field: 'requiredRevisionNumber',
      headerStyle: { zIndex: 10 }
    }
  ];

  const auditHistoryTableActions: any = [
    {
      icon: () => (
        <Button
          data-id="Compare-Button"
          id="Compare-Button"
          disableElevation
          variant="outlined"
          color="primary"
          onClick={handleCompareJSON}
        >
          Compare
        </Button>
      ),
      position: 'toolbarOnSelect'
    },
    {
      icon: () => <ViewDetails />,
      onClick: (event: any, rowData: any) => handleViewDetails(rowData),
      tooltip: 'View Details',
      position: 'row'
    }
  ];

  const handleViewDetails = (rowData: any) => {
    setRequest(rowData?.entity);
  };

  const diff = (entity1: any, entity2: any) => {
    const result: any = {};
    if (Object.is(entity1, entity2)) {
      return undefined;
    }
    if (!entity2 || typeof entity2 !== 'object') {
      return entity2;
    }
    Object.keys(entity1 || {})
      .concat(Object.keys(entity2 || {}))
      .forEach(key => {
        if (entity2[key] !== entity1[key] && !Object.is(entity1[key], entity2[key])) {
          result[key] = entity2[key];
        }
        if (typeof entity2[key] === 'object' && typeof entity1[key] === 'object') {
          const value = diff(entity1[key], entity2[key]);
          if (value !== undefined) {
            result[key] = value;
          }
        }
      });
    return result;
  };

  const handleCompareJSON = () => {
    const result = diff(entity1, entity2);
    setRequest(result);
  };

  const onRowSelection = (selected: any) => {
    setRequest({});
    Object.keys(selected).map(key => {
      if (key === '0') setEntity1(selected[0]?.entity);
      else setEntity2(selected[1]?.entity);
    });
  };

  const jsonRequestEditorRef = useRef<any>();

  useEffect(() => {
    if (jsonRequestEditorRef && jsonRequestEditorRef.current) {
      jsonRequestEditorRef.current.set(request);
      jsonRequestEditorRef.current.expandAll && jsonRequestEditorRef.current.expandAll();
    }
  }, [request]);

  const setRequestEditorRef = (instance: any) => {
    if (instance) {
      jsonRequestEditorRef.current = instance.jsonEditor;
    } else {
      jsonRequestEditorRef.current = null;
    }
  };

  const handleEventDialogClose = () => {
    props.handleDialogClose();
    setRequest({});
  };

  return (
    <div>
      <Dialog onClose={props.handleDialogClose} open={props.dialogOpen} fullWidth={true} maxWidth="xl">
        <DialogTitle id="customized-dialog-title">View Audit History</DialogTitle>
        <DialogContent dividers>
          {props.refresh ? (
            <Loading />
          ) : (
            <div>
              <Grid container style={{ width: 'auto' }}>
                <>
                  <Grid item xs={5} style={{ margin: '5px' }}>
                    <Typography variant="h3">{'Audit History'}</Typography>
                    <DetailedTable
                      key="auditInfo"
                      id={props.tableId || 'auditGrid'}
                      title={''}
                      data={props.formData || []}
                      columns={subcolumns}
                      showSearch={false}
                      showSelection={true}
                      onSelection={onRowSelection}
                      actionsColumnIndex={0}
                      showPagination={true}
                      count={props?.totalElements}
                      rowsPerPage={10}
                      tableActions={auditHistoryTableActions}
                    />
                  </Grid>

                  <Grid item xs={1}></Grid>
                  <Grid item xs={5} style={{ margin: '5px' }}>
                    <Typography variant="h3">{'Entity'}</Typography>
                    <JsonEditor
                      setRef={setRequestEditorRef}
                      id={`jsonRequestEditor-${props?.formData?.eventId}`}
                      data={request}
                      mode={props.mode}
                    />
                  </Grid>
                </>
              </Grid>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleEventDialogClose} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AuditDetailsDialog;
